
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './src/styles/globals.css';
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from './src/contexts/AuthContext';
import { NotificationProvider } from './src/contexts/NotificationContext';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from './src/components/theme-provider';
import { ErrorBoundary } from './src/components/ErrorBoundary';
import { logger } from './src/utils/logger';
import { setupApiLogging } from './src/utils/api-logger';

logger.info('Application initializing', 'App');

setupApiLogging();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      gcTime: 10 * 60 * 1000,
      retry: 2,
      refetchOnWindowFocus: false,
    },
  },
});

createRoot(document.getElementById('root')!).render(
   <BrowserRouter>
      <ThemeProvider>
        <QueryClientProvider client={queryClient}>
          <ErrorBoundary>
            <AuthProvider>
              <NotificationProvider>
                <App />
              </NotificationProvider>
            </AuthProvider>
          </ErrorBoundary>
        </QueryClientProvider>
      </ThemeProvider>
    </BrowserRouter>
);